// extracted by mini-css-extract-plugin
module.exports = {"link":"RedeemButton__link__PY5BO"};